import React from 'react';
import { CustomerLayout } from '../../components/layouts/CustomerLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { Shield, AlertTriangle, Plus, FileText, ChevronLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { toPersianDigits, formatCurrency } from '../../utils/persian';
export function DashboardPage() {
  return <CustomerLayout data-id="element-358">
      <div className="space-y-8" data-id="element-359">
        {/* Welcome Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-360">
          <div data-id="element-361">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-362">
              سلام، علی عزیز 👋
            </h1>
            <p className="text-gray-500 mt-1" data-id="element-363">به پنل کاربری خود خوش آمدید</p>
          </div>
          <Link to="/insurance/select" data-id="element-364">
            <Button className="w-full md:w-auto" data-id="element-365">
              <Plus className="ml-2 h-4 w-4" data-id="element-366" />
              خرید بیمه جدید
            </Button>
          </Link>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-367">
          <Card className="bg-blue-50 border-blue-100" data-id="element-368">
            <CardContent className="p-6 flex items-center gap-4" data-id="element-369">
              <div className="p-3 bg-blue-100 rounded-full text-blue-600" data-id="element-370">
                <Shield className="h-6 w-6" data-id="element-371" />
              </div>
              <div data-id="element-372">
                <p className="text-sm text-blue-600 font-medium" data-id="element-373">
                  بیمه‌های فعال
                </p>
                <p className="text-2xl font-bold text-blue-900" data-id="element-374">
                  {toPersianDigits(2)}
                </p>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-orange-50 border-orange-100" data-id="element-375">
            <CardContent className="p-6 flex items-center gap-4" data-id="element-376">
              <div className="p-3 bg-orange-100 rounded-full text-orange-600" data-id="element-377">
                <AlertTriangle className="h-6 w-6" data-id="element-378" />
              </div>
              <div data-id="element-379">
                <p className="text-sm text-orange-600 font-medium" data-id="element-380">
                  در حال انقضا
                </p>
                <p className="text-2xl font-bold text-orange-900" data-id="element-381">
                  {toPersianDigits(1)}
                </p>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-green-50 border-green-100" data-id="element-382">
            <CardContent className="p-6 flex items-center gap-4" data-id="element-383">
              <div className="p-3 bg-green-100 rounded-full text-green-600" data-id="element-384">
                <FileText className="h-6 w-6" data-id="element-385" />
              </div>
              <div data-id="element-386">
                <p className="text-sm text-green-600 font-medium" data-id="element-387">
                  پرونده‌های خسارت
                </p>
                <p className="text-2xl font-bold text-green-900" data-id="element-388">
                  {toPersianDigits(0)}
                </p>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Active Policies */}
        <div className="space-y-4" data-id="element-389">
          <div className="flex items-center justify-between" data-id="element-390">
            <h2 className="text-lg font-bold text-gray-900" data-id="element-391">
              بیمه‌نامه‌های من
            </h2>
            <Link to="/policies" className="text-sm text-primary hover:underline flex items-center" data-id="element-392">
              مشاهده همه
              <ChevronLeft className="h-4 w-4 mr-1" data-id="element-393" />
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-394">
            {/* Policy Card 1 */}
            <Card className="hover:shadow-md transition-shadow cursor-pointer border-l-4 border-l-green-500" data-id="element-395">
              <CardContent className="p-6" data-id="element-396">
                <div className="flex justify-between items-start mb-4" data-id="element-397">
                  <div className="flex items-center gap-3" data-id="element-398">
                    <div className="h-10 w-10 rounded-lg bg-gray-100 flex items-center justify-center" data-id="element-399">
                      🚗
                    </div>
                    <div data-id="element-400">
                      <h3 className="font-bold text-gray-900" data-id="element-401">بیمه شخص ثالث</h3>
                      <p className="text-sm text-gray-500" data-id="element-402">پژو ۲۰۶ - ۱۴۰۲</p>
                    </div>
                  </div>
                  <Badge variant="success" data-id="element-403">فعال</Badge>
                </div>

                <div className="space-y-2 text-sm text-gray-600 mb-4" data-id="element-404">
                  <div className="flex justify-between" data-id="element-405">
                    <span data-id="element-406">شرکت بیمه:</span>
                    <span className="font-medium text-gray-900" data-id="element-407">
                      بیمه ایران
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-408">
                    <span data-id="element-409">تاریخ انقضا:</span>
                    <span className="font-medium text-gray-900" data-id="element-410">
                      {toPersianDigits('1403/12/29')}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-411">
                    <span data-id="element-412">شماره بیمه‌نامه:</span>
                    <span className="font-medium text-gray-900" data-id="element-413">
                      {toPersianDigits('123456789')}
                    </span>
                  </div>
                </div>

                <div className="pt-4 border-t flex gap-2" data-id="element-414">
                  <Button variant="outline" size="sm" className="flex-1" data-id="element-415">
                    مشاهده جزئیات
                  </Button>
                  <Button variant="ghost" size="sm" className="text-primary" data-id="element-416">
                    تمدید
                  </Button>
                </div>
              </CardContent>
            </Card>

            {/* Policy Card 2 */}
            <Card className="hover:shadow-md transition-shadow cursor-pointer border-l-4 border-l-orange-500" data-id="element-417">
              <CardContent className="p-6" data-id="element-418">
                <div className="flex justify-between items-start mb-4" data-id="element-419">
                  <div className="flex items-center gap-3" data-id="element-420">
                    <div className="h-10 w-10 rounded-lg bg-gray-100 flex items-center justify-center" data-id="element-421">
                      🏠
                    </div>
                    <div data-id="element-422">
                      <h3 className="font-bold text-gray-900" data-id="element-423">بیمه آتش‌سوزی</h3>
                      <p className="text-sm text-gray-500" data-id="element-424">منزل مسکونی</p>
                    </div>
                  </div>
                  <Badge variant="warning" data-id="element-425">نیاز به تمدید</Badge>
                </div>

                <div className="space-y-2 text-sm text-gray-600 mb-4" data-id="element-426">
                  <div className="flex justify-between" data-id="element-427">
                    <span data-id="element-428">شرکت بیمه:</span>
                    <span className="font-medium text-gray-900" data-id="element-429">
                      بیمه پاسارگاد
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-430">
                    <span data-id="element-431">تاریخ انقضا:</span>
                    <span className="font-medium text-orange-600" data-id="element-432">
                      {toPersianDigits('1403/09/15')}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-433">
                    <span data-id="element-434">شماره بیمه‌نامه:</span>
                    <span className="font-medium text-gray-900" data-id="element-435">
                      {toPersianDigits('987654321')}
                    </span>
                  </div>
                </div>

                <div className="pt-4 border-t flex gap-2" data-id="element-436">
                  <Button variant="outline" size="sm" className="flex-1" data-id="element-437">
                    مشاهده جزئیات
                  </Button>
                  <Button size="sm" className="flex-1" data-id="element-438">
                    تمدید آنلاین
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </CustomerLayout>;
}